import { pixelMultiplier } from '../settings/scheduler';

const capitalFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);
const lowerFirstLetter = string => string.charAt(0).toLowerCase() + string.slice(1);
const durationToPixels = value => {
  return value ? `${value * pixelMultiplier}px` : 'auto';
};
const cardWidthToPixels = value => `${value * pixelMultiplier}`;
const checkFeatureAccess = (featureAccesseList, requiredFeatureAccess) => {
  if (Array.isArray(requiredFeatureAccess)) {
    return requiredFeatureAccess.some(fA => featureAccesseList.includes(fA));
  }
  return featureAccesseList.includes(requiredFeatureAccess);
};

const checkAllFeatureAccess = (requiredFeatureAccess, featureAccesseList) => {
  if (Array.isArray(requiredFeatureAccess)) {
    return requiredFeatureAccess.every(fA => featureAccesseList.includes(fA));
  }
  return featureAccesseList.includes(requiredFeatureAccess);
};

function refSetter(name) {
  const self = this;
  return element => {
    self[name] = element;
  };
}

const paramHasValue = param => param !== null && typeof param !== 'undefined';

const querizeSingle = param =>
  paramHasValue(param.value) ? `${param.key.toLowerCase()}=${param.value.toString()}` : '';

const querizeArray = param =>
  param.value.reduce((querizedSoFar, value) => {
    const joiner = querizedSoFar ? '&' : '';
    const querizedSingle = querizeSingle({ key: param.key, value });

    return querizedSingle ? `${querizedSoFar}${joiner}${querizedSingle}` : querizedSoFar;
  }, '');

const querize = param => (Array.isArray(param.value) ? querizeArray(param) : querizeSingle(param));

const queryStringBuilder = paramsObject => {
  const paramsKeys = Object.keys(paramsObject);
  const params = paramsKeys.map(key => ({ key, value: paramsObject[key] }));

  return params.reduce((querySoFar, param) => {
    const joiner = querySoFar ? '&' : '?';
    const paramQuerized = querize(param);

    return paramQuerized ? `${querySoFar}${joiner}${paramQuerized}` : querySoFar;
  }, '');
};

export function queryStringBuilder1(paramsObject) {
  const paramsKeys = Object.keys(paramsObject);
  const params = paramsKeys.map(key => ({ key, value: paramsObject[key] }));

  return params.reduce((querySoFar, param) => {
    const joiner = querySoFar ? '&' : '?';
    const paramQuerized = querize(param);

    return paramQuerized ? `${querySoFar}${joiner}${paramQuerized}` : querySoFar;
  }, '');
}

function insertSpaces(string, indexes) {
  if (Array.isArray(indexes)) {
    if (!indexes.every(value => typeof value === 'number')) {
      throw new Error('Indexes must be numbers.');
    }
    const sortedIndexes = indexes.sort((a, b) => a - b);
    let result = string;
    for (let i = 0; i < sortedIndexes.length; i += 1) {
      result = `${result.slice(0, sortedIndexes[i] + 1 * i)} ${result.slice(sortedIndexes[i] + 1 * i)}`;
    }
    return result;
  }
  if (typeof indexes !== 'number') {
    throw new Error('Index must be a number.');
  }
  return `${string.slice(0, indexes)} ${string.slice(indexes)}`;
}

function formatNhs(nhsNumber) {
  return nhsNumber ? insertSpaces(nhsNumber, [3, 6]) : '';
}

function doubleActionPrevent(actionIdentifier, actionFunction = () => {}, callback = () => {}) {
  if (!actionIdentifier || typeof actionIdentifier !== 'string') {
    throw new TypeError('DoubleActionPrevent: Must specify a string action identifier.');
  }
  const stateIdentifier = `preventDouble${actionIdentifier}`;
  return async (...params) => {
    if (this.state && this.state[stateIdentifier]) {
      return;
    }
    this.setState({ [stateIdentifier]: true });
    try {
      await actionFunction(...params);
    } catch (err) {
      return;
    } finally {
      this.setState({ [stateIdentifier]: false });
    }
    await callback(...params);
  };
}

const createPrimarySelector = selector => state => {
  try {
    return selector(state);
  } catch (err) {
    return null;
  }
};

const stringToArray = string => {
  return string.split(', ').map(x => x.trim());
};

const removeSpaces = str => {
  return str.replace(/\s/g, '');
};

const production = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export {
  capitalFirstLetter,
  lowerFirstLetter,
  durationToPixels,
  cardWidthToPixels,
  checkFeatureAccess,
  checkAllFeatureAccess,
  refSetter,
  queryStringBuilder,
  production,
  doubleActionPrevent,
  insertSpaces,
  formatNhs,
  createPrimarySelector,
  stringToArray,
  removeSpaces,
};
